import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/supabase/client'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (loading) return

    if (!password) {
      setError('Please enter a new password.')
      return
    }

    setError('')
    setLoading(true)

    try {
      const { error: updateError } = await supabase.auth.updateUser({ password })
      if (updateError) {
        throw updateError
      }

      navigate('/login', { replace: true })
    } catch (updateError) {
      console.error('Password update failed', updateError)
      setError(updateError.message || 'Unable to update password.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-md mx-auto w-full py-12">
      <h1 className="text-2xl font-semibold text-cocoa">Reset your password</h1>
      <p className="mt-2 text-sm text-cocoa/70">Enter a new password to continue.</p>
      <form onSubmit={handleSubmit} className="mt-6 space-y-4">
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-cocoa">
            New password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            className="mt-1 w-full rounded-xl border border-sand bg-white px-3 py-2 text-cocoa shadow-soft focus:border-brick focus:outline-none focus:ring-2 focus:ring-brick/40"
            minLength={8}
            autoComplete="new-password"
            required
          />
        </div>
        {error ? <p className="text-sm text-brick">{error}</p> : null}
        <button
          type="submit"
          className="w-full rounded-xl bg-brick px-3 py-2 font-semibold text-white shadow-soft transition hover:bg-brickDark disabled:opacity-70"
          disabled={loading}
        >
          {loading ? 'Updating…' : 'Update password'}
        </button>
      </form>
    </div>
  )
}
